<template>
  <div v-if="disabled">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on">
          <v-btn class="mx-2 action-btn" color="primary" :disabled="disabled">
            {{ label }}
          </v-btn>
        </div>
      </template>

      <span>{{ disabledMessage }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    <v-btn class="mx-2 action-btn" color="primary" @click="$emit('click')">
      {{ label }}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    disabled: { type: Boolean, default: false },
    disabledMessage: { type: String, default: 'Disabled' },
    label: { type: String, default: '' },
  },
};
</script>
